import AddonCard from './AddonCard.component';

export default AddonCard;
